export default __webpack_public_path__ + "static/GBEA-logo-0251e9829e79bd9d740ba5278363baca.png";